import { MediaMatcher } from '@angular/cdk/layout';
import { ChangeDetectorRef, Component, OnDestroy, inject } from '@angular/core';
import { MatListModule } from '@angular/material/list';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { RouterOutlet } from '@angular/router';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatMenuModule } from '@angular/material/menu';
import { ThemeService } from './services/theme.service';
import { TokenExpirationService } from './services/token-expiration.service';
import { PasswordExpirationService } from './services/password-expiration.service';
import { environment } from '../environments/environment';
import { AuthService } from './services/auth.service';

@Component({
  selector: 'app-root',
  imports: [
    MatToolbarModule,
    MatButtonModule,
    MatIconModule,
    MatSidenavModule,
    MatListModule,
    RouterOutlet,
    MatMenuModule,
    MatExpansionModule,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  /*Manejo de thema*/
  themeService: ThemeService = inject(ThemeService);
  toogleTheme = () => this.themeService.updateTheme();
  evnProd = environment.production

  loginOk = false;

  authService: AuthService = inject(AuthService);

  constructor(
    private tokenExpirationService: TokenExpirationService,
    private passwordExpirationService: PasswordExpirationService
  ) { }

  ngOnInit(): void {    
    this.tokenExpirationService.startTokenCheck();
    this.passwordExpirationService.initializeCheck();
    this.loginOk = this.authService.isAuthenticated();
    if(this.loginOk){
      //this.authService.initEventNotification();
    }
  }

  ngOnDestroy(): void {
    this.tokenExpirationService.stopTokenCheck();
  }
}
